import http from "./http";

/* ================= GET TEACHERS ================= */
export const getTeachers = async () => {
  try {
    const res = await http.post("manage_teachers?action=get");
    return res.data;
  } catch (error) {
    console.error("GET TEACHERS ERROR:", error);
    return error?.response?.data || { status: false, data: [] };
  }
};

/* ================= ADD TEACHER ================= */
export const addTeacher = async (data) => {
  try {
    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("password", data.password);
    formData.append("class_ids", data.class_ids.join(","));

    const res = await http.post(
      "manage_teachers?action=add",
      formData
    );

    return res.data;
  } catch (error) {
    console.error("ADD TEACHER ERROR:", error);
    return error?.response?.data || { status: false, message: error.message };
  }
};

/* ================= UPDATE TEACHER ================= */
export const updateTeacher = async (id, data) => {
  try {
    const payload = {
      id: id.toString(),
      name: data.name,
      email: data.email, // ✅ added (backend expects it)
      password: data.password,
      class_ids: data.class_ids, // ✅ send as array (JSON जैसा Postman)
    };

    const res = await http.post(
      "manage_teachers?action=update",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error("UPDATE TEACHER ERROR:", error);
    return error?.response?.data || { status: false, message: error.message };
  }
};

/* ================= DELETE TEACHER ================= */
export const deleteTeacher = async (id) => {
  try {
    const res = await http.post(
      `manage_teachers?action=delete&id=${id}`
    );

    return res.data;
  } catch (error) {
    console.error("DELETE TEACHER ERROR:", error);
    return error?.response?.data || { status: false, message: error.message };
  }
};